import * as React from 'react';
import { SVGProps } from 'react';

const IconCancelSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0zm-2 0a5 5 0 0 1-7.757 4.172l6.929-6.93A4.99 4.99 0 0 1 13 8zm-9.172 2.757 6.93-6.929a5 5 0 0 0-6.929 6.929z"
    />
  </svg>
);
export default IconCancelSizeS;
